import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'dispatchCounters/';

const initialState = {
    counters: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchDispatchCounters = createAsyncThunk(
    'dispatchCounters/fetchAll',
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(API_URL + 'list');
            return res.data.counters || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createDispatchCounter = createAsyncThunk(
    'dispatchCounters/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateDispatchCounter = createAsyncThunk(
    'dispatchCounters/update',
    async ({ dispatchCounterId, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `update/${dispatchCounterId}`, data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateDispatchCounterStatus = createAsyncThunk(
    'dispatchCounters/status',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + 'status', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deleteDispatchCounter = createAsyncThunk(
    'dispatchCounters/delete',
    async (dispatchCounterId, thunkAPI) => {
        try {
            const res = await axios.delete(API_URL + `delete/${dispatchCounterId}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const dispatchCounterSlice = createSlice({
    name: 'dispatchCounters',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDispatchCounters.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchDispatchCounters.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.counters = action.payload;
            })
            .addCase(fetchDispatchCounters.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createDispatchCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createDispatchCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createDispatchCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateDispatchCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDispatchCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateDispatchCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updateDispatchCounterStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDispatchCounterStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updateDispatchCounterStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deleteDispatchCounter.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDispatchCounter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deleteDispatchCounter.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = dispatchCounterSlice.actions;
export default dispatchCounterSlice.reducer;
